import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from './supabaseConfig'

/**
 * One shared browser client. Only the publishable (anon) key is ever used —
 * every read/write here goes through a token-checked database function
 * (see utils/shootDayApi.ts), never a direct table query, so there is no
 * Supabase Auth session to manage on this app at all.
 */

const url = SUPABASE_URL
const key = SUPABASE_PUBLISHABLE_KEY

export const supabaseConfigured = Boolean(url && key)

export const supabase: SupabaseClient | null = supabaseConfigured
  ? createClient(url, key, { auth: { persistSession: false } })
  : null

if (!supabaseConfigured) {
  console.error('[supabase] client not created — URL or publishable key missing.')
}
